<template>
  <div lang="tr" class="vertical-align-step-0">
    <h3 class="main_question text-center font-weight-normal">
      {{ $t('Hangi şirket türünü seçmeliyim?') }}
      <a
        id="howToChoose"
        data-target="#how-to-choose-modal"
        data-toggle="modal"
        href="#"
        class="btn-outline-mukellef btn-radius ml-2 mt-2"
      >
        <i class="fa fa-play link-button-icon"></i><span>{{ $t('Videoyu İzleyin') }}</span>
      </a>
    </h3>
    <form method="POST" id="step0" @submit="sendForm">
      <div v-for="(pricegroup, index) in chunkArr(products.slice(1, -2), 2)" :key="index">
        <h3 class="main_question mt-4" v-if="index === 0">{{ $t('Bireysel') }}</h3>
        <h3 class="main_question mt-3" v-if="index === 1">{{ $t('Kurumsal') }}</h3>
        <div
          @click="selectedCompanyType = price"
          v-for="price in pricegroup"
          class="box-border"
          :key="price.id"
          v-bind:class="{ 'selected-product': selectedCompanyType.code === price.code }"
        >
          <div class="d-flex justify-content-between">
            <div class="vertical-center ml-1">
              <div>
                <p class="mb-1 font-weight-bold">{{ price.name }}</p>
              </div>
            </div>

            <div class="text-center vertical-center product-image">
              <img v-if="price.code === 'SIMPLE'" src="/img/company-types/basit.svg" class="company-type" />
              <img
                v-if="price.code === 'OPERATION'"
                src="/img/company-types/isletme.svg"
                class="company-type-default"
              />
              <img
                v-if="price.code === 'SELFEMP'"
                src="/img/company-types/serbest-meslek.svg"
                class="company-type-big"
              />
              <img v-if="price.code === 'LIMITED'" src="/img/company-types/limited.svg" class="company-type-medium2" />
              <img v-if="price.code === 'CORPORATION'" src="/img/company-types/anonim.svg" class="company-type-big" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCompanyType.has_title">
        <h3 class="main_question mt-4">{{ $t('Ünvan') }}</h3>
        <div class="row">
          <div class="col-12">
            <InputField
              v-model.trim="title"
              name="company_title"
              :placeholder="$t('Şirket Ünvanı')"
              v-validate="'required|min:3|check_title'"
              v-tippy="$t('Şirketinizin ünvanını giriniz')"
              :error="errors.first('company_title')"
              :validateFields="fields['company_title']"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
/* eslint-disable camelcase */

import RegisterStore from '../../../../stores/register';
import CompanyStore from '../../../../stores/company';
import TokenStore from '@/stores/token';
import InputField from './../../../InputField.vue';

export default {
  components: {
    InputField,
  },
  data() {
    return {
      isCompanyTitle: true,
      products: [],
      selectedCompanyType: {},
      title: '',
      company: {},
      defaultSelectedCompanyType: 'OPERATION',
      chunkArrData: [],
    };
  },
  created() {
    this.startWaiting();
    $axios.all([this.getTypesData(), this.getCompanyData()]).then(
      $axios.spread((first_response, second_response) => {
        this.products = first_response.data.data;
        if (second_response) {
          this.company = second_response.data.data[0];
          this.title = this.selectedCompanyType.has_title ? this.company.name : this.company.users.data[0].fullname;
          const selectedCompanyType = this.company.companyType.data;
          if (this.products.find((e) => e.code === selectedCompanyType.code)) {
            this.selectedCompanyType = selectedCompanyType;
          } else {
            this.selectedCompanyType = this.products.find((e) => e.code === this.defaultSelectedCompanyType);
          }
        }
        this.endWaiting();
      })
    );
  },
  methods: {
    getTypesData() {
      return CompanyStore.dispatch('getTypes', {
        company_nation_id: 1,
      });
    },
    getCompanyData() {
      if (this.$route.query.companyId !== 'newuser') {
        return CompanyStore.dispatch('getCompany');
      }
      return null;
    },
    chunkArr: function (array, size, guard) {
      const length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }

      let index = 0;
      let resIndex = 0;
      const result = Array(Math.ceil(length / size));

      while (index < length) {
        result[resIndex++] = this.baseSlice(array, index, (index += size));
      }
      this.chunkArrData = result;
      return result;
    },
    baseSlice: function (array, start, end) {
      let index = -1;
      let length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : length + start;
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end - start) >>> 0;
      start >>>= 0;

      const result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    },
    async sendForm(callback) {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          let isUserSelectedCompany = false;

          this.chunkArrData.forEach((element) => {
            const result = element.find((x) => x.id === this.selectedCompanyType.id);
            if (result) {
              isUserSelectedCompany = true;
            }
          }, this);

          if (!isUserSelectedCompany) {
            this.$toasted.error(this.$t('AlertMessages.Lütfen Firma tipi seçiniz'));
            return;
          }
          if (this.$route.query.companyId === 'newuser') {
            this.startWaiting();
            await RegisterStore.dispatch('createCompany', {
              company_nation_id: 1,
            })
              .then((s) => {
                const token = s.data.token;
                TokenStore.commit('setOnlyAccessToken', token);
                const query = Object.assign({}, this.$route.query);
                delete query.companyId;
                this.$router.replace({ path: this.$route.path, query: query });
              })
              .finally((s) => {
                this.endWaiting();
              });
          }

          this.startWaiting();
          RegisterStore.dispatch('step1', {
            company_type_id: this.selectedCompanyType.id,
            company_type_code: this.selectedCompanyType.code,
            name: this.selectedCompanyType.has_title
              ? this.title
              : this.company.users
              ? this.company.users.data[0].fullname
              : undefined,
            register_type: 'register',
          }).then((s) => {
            if (s.data.success === false) {
              this.$toasted.error(this.$t('AlertMessages.Lütfen Firma tipi seçiniz'));
              this.endWaiting();
              return;
            }
            this.$store.commit('setCompanyId', s.data.data.id);
            callback();
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.startup-package {
  background: #f4f9fc;
  border: 1px solid rgba(4, 89, 129, 0.06);
  /* box-shadow:0 3px 6px rgba(0,10,50,0.13); */
}

.additional-msg {
  background: rgba(4, 89, 129, 0.06);
  color: rgba(4, 89, 129, 1);
  border-radius: 0 0 0.25rem 0.25rem;
}

.additional-msg a {
  color: rgba(4, 89, 129, 1);
  text-decoration: underline;
}

.vertical-center {
  margin-top: auto;
  margin-bottom: auto;
}

h3.main_question {
  font-size: 1rem;
}

.overline {
  text-decoration: line-through;
}

@media screen and (max-width: 600px) {
  .startup-additional-package .features {
    text-align: center !important;
  }
}
</style>
